export const shortenTicketId = (id, head = 4, tail = 4) => {
  if (!id) return '—';
  const value = String(id);
  if (value.length <= head + tail + 1) return value;
  return `${value.slice(0, head)}…${value.slice(-tail)}`;
};
